import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService, fromDaysToMilliseconds } from "@obg/ngx.global";

/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
@Injectable({
	providedIn: "root",
})
export class MissingPasswordConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getMissingPasswordEnabled(): boolean {
		return this.configService.get((x) => x.common.setMissingPassword.isEnabled, false);
	}

	getMissingPasswordEndpoint(): string {
		return this.configService.get((x) => x.common.setMissingPassword.endpoint, "v1/credentials/uc/login-token");
	}

	getMissingPasswordTimeout(): number {
		return this.configService.get((x) => x.common.setMissingPassword.timeout, 180000);
	}

	getSkipMissingPasswordMaxAgeCache(): number {
		return fromDaysToMilliseconds(this.configService.get((x) => x.common.setMissingPassword.skipCacheMaxAge, 30));
	}
}
